import { FC } from 'react';
import { PrismicRichText } from '@prismicio/react';
import { ModalBodyContentProps } from '@/types';
import { ModalSliceElectronicConsentPrimary } from '../../../../../prismicio-types';

export const ElectronicConsent: FC<
  ModalBodyContentProps<ModalSliceElectronicConsentPrimary>
> = ({ data, styles, components }) => {
  return (
    <>
      <PrismicRichText field={data.title} components={components} />
      <div className={styles.textWrapper}>
        <PrismicRichText components={components} field={data.description} />
      </div>
    </>
  );
};
